<script>
    import DialogBase from "../dialog/components/dialog-base.vue";
    import DialogHeader from "../dialog/components/dialog-header.vue";
    import DialogBody from "../dialog/components/dialog-body.vue";
    import DialogButton from "../dialog/components/dialog-button.vue";
    import DialogActionbar from "../dialog/components/dialog-actionbar.vue";

    export default {
        components: {DialogActionbar, DialogButton, DialogBody, DialogHeader, DialogBase},
        data() {
            return {
                showDialog: false,
                data: undefined,
                type: undefined,
                task: undefined,
                id: undefined,
            }
        },
        computed: {
            title() {
                return `${this.task} ${this.type}`;
            },
            translations() {
                return {
                    hint: Lang.langGet("This behavior can be changed in the dropdown menu of the :task button.", {task: Lang.langGet(this.task)}),
                    cancel: Lang.langGet("Cancel"),
                    ok: Lang.langGet("Ok"),
                    okRemember: Lang.langGet("Ok and do not ask again"),
                    autoPublish: Lang.langGet("Layers that contain the modified content get published to the relevant screens."),
                    proceed: Lang.langGet("Are you sure you want to save now?"),
                }
            },
        },
        methods: {
            handleCancel() {
                this.showDialog = false;
            },
            confirm: function (proceed, remember = false) {
                if (proceed && remember) {
                    localStorage.setItem(this.type  + "-autopublish-confirm-" + Laravel.activeProject, '1');
                }
                this.showDialog = false;
                EaseEventBus.fire('updateProceed', {data: this.data, proceed: proceed, type: this.type, task: this.task, id: this.id});
            }
        },
        mounted() {
            EaseEventBus.listen('showAutopublishWarning', params => {
                this.data = params.data;
                this.type = params.type;
                this.task = params.task;
                this.id = params.id;
                this.showDialog = true;
            });
        }
    }
</script>

<template>
    <dialog-base
        :maxWidth="600"
        :showDialog="showDialog"
        persistent
        @close="handleCancel"
    >
        <dialog-header
            :title="title"
            @close="handleCancel"
        />
        <dialog-body>
            <div class="ma-4 autopublish-modal-content">
                <p class="text-center">
                    {{ translations.autoPublish }}<br>
                    {{ translations.hint }}<br>
                    {{ translations.proceed }}
                </p>
            </div>
        </dialog-body>
        <dialog-actionbar
            noIcons
            :abortText="translations.cancel"
            :confirmText="translations.ok"
            @close="confirm(false)"
            @save="confirm(true)"
        >
            <dialog-button
                class="mr-1"
                :color="'primary'"
                @click="confirm(true, true)"
            >
                {{translations.okRemember}}
            </dialog-button>
        </dialog-actionbar>
    </dialog-base>
</template>

<style scoped>
    .autopublish-modal-content {
        font-size: 16px;
        margin: 26px 16px 10px 18px !important;
    }
</style>
